export { default as PrintRootContainer } from './PrintRootContainer'
export { default as PrintContainer } from './PrintContainer'
import { print } from './module'

export const actions = {
    print
}
